export default "__VITE_PUBLIC_ASSET__13231cb7__"